import { useMemo } from 'react';
import { useFilesBase, FileListItem } from './use-files-base';

const dummyFiles: FileListItem[] = [
  { id: '1', name: 'Proposal_Draft.pdf', size: '2.4 MB', date: 'Mar 12, 2026', source: 'email' },
  { id: '2', name: 'Technical_Spec.docx', size: '890 KB', date: 'Feb 20, 2026', source: 'email' },
  { id: '3', name: 'Meeting_Notes_Feb12.pdf', size: '340 KB', date: 'Feb 12, 2026', source: 'meeting' },
];

interface UseContactFilesOptions {
  skip?: boolean;
}

export const useContactFiles = (contactId: string, options: UseContactFilesOptions = {}) => {
  const entityFilter = useMemo(() => ({ contactId }), [contactId]);

  return useFilesBase({
    entityFilter,
    entityId: contactId,
    skip: options.skip,
    dummyFiles,
  });
};
